"use client";

import { Cake, Heart, Circle, ChefHat } from "lucide-react";

type IconType = 'ChefHat' | 'Circle' | 'Heart' | 'Cake';

const iconMap: Record<IconType, React.ComponentType<{ className?: string }>> = {
  ChefHat,
  Circle,
  Heart,
  Cake,
};

interface PricingIconsProps {
  icon: IconType;
  className?: string;
}

export function PricingIcons({ icon, className = "w-6 h-6 text-primary" }: PricingIconsProps) {
  const Icon = iconMap[icon];
  return <Icon className={className} />;
}
